import { useEffect, useRef } from "react";

/**
 * Chama `recarregar` a cada `intervaloMs` enquanto a aba estiver à vista.
 *
 * Aba escondida não consulta nada, e a volta dispara uma consulta na hora — quem voltou não fica
 * olhando dado velho até o próximo tique. Uma chamada nunca começa por cima da anterior: o backend
 * roda com uma requisição por instância no Cloud Run, e tique empilhado vira fila lá.
 *
 * `intervaloMs` zero ou nulo desliga. A função fica numa ref para o intervalo não recomeçar a cada
 * renderização de quem usa o hook.
 */
export default function useRecargaPeriodica(recarregar, intervaloMs) {
  const recarregarRef = useRef(recarregar);

  useEffect(() => {
    recarregarRef.current = recarregar;
  }, [recarregar]);

  useEffect(() => {
    if (!intervaloMs) return undefined;

    let emAndamento = false;
    const tique = async () => {
      if (emAndamento || document.visibilityState === "hidden") return;
      emAndamento = true;
      try {
        await recarregarRef.current();
      } catch (erro) {
        console.error("Erro na recarga periódica da tela:", erro);
      } finally {
        emAndamento = false;
      }
    };

    const aoMudarDeAba = () => {
      if (document.visibilityState === "visible") tique();
    };

    const intervalo = window.setInterval(tique, intervaloMs);
    document.addEventListener("visibilitychange", aoMudarDeAba);

    return () => {
      window.clearInterval(intervalo);
      document.removeEventListener("visibilitychange", aoMudarDeAba);
    };
  }, [intervaloMs]);
}
